import * as THREE from "three";

export const existingChannelIDs = new Set<number>();
export const existingUserIDs = new Set<number>();
export const billboardEls = new Set<THREE.Object3D>();
export const linesToBillboardEls = new Set<THREE.Object3D>();
export const upcomingConnections = new Set<THREE.Object3D>();

export const interactedObjects: THREE.Object3D[] = [];
export const channelJourney: string[] = [];
export const landingStuff: Array<THREE.Object3D | null | undefined> = [];
export const walkthrough: Array<THREE.Object3D | null | undefined> = [];
export const pathwayItems: Array<THREE.Object3D | null | undefined> = [];
